import comp from "./AssessmentCategory";
export default comp;
